import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useTrackingManager } from '../useTrackingManager';
import type { CtaButtonProps } from './CtaBar';
import { getCtaLabel } from '../../lib/ctaLabel';

export type ClickHandler = (
  event: React.MouseEvent<HTMLElement>,
  cta: string,
  label: string,
) => unknown;

export type CtaCallbackButtonProps = CtaButtonProps & {
  clickHandler: ClickHandler;
};

export const CtaCallbackButton = ({
  variant,
  clickHandler,
  label,
  displayname,
  position,
}: CtaCallbackButtonProps): React.ReactElement => {
  const trackingManager = useTrackingManager();
  return (
    <TextButton
      variant={variant}
      onClick={(event) => {
        clickHandler(event as React.MouseEvent<HTMLElement>, `${variant}-cta${position}`, label);
        trackingManager.click('exit_link', '', 'cta', label, displayname, position, label);
      }}
    >
      {getCtaLabel(label)}
    </TextButton>
  );
};
